export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14181.5cecc7df.jpg";